<div class="subBlockContainer">

  <div class="subBlockContent" *ngIf="!isMiniBlade">
      <child-header [title]="renewalsTitle" [showDownload]="true" titleDownload="Download Renewals" (downloadEvent)="exportRenewalsReport()"
      [showClone]="true" titleClone="Copy Renewals link" (cloneEvent)="copyRenewalsLink()" (closeEvent)="navigateTo('/home')"></child-header>
      <div *ngIf="loadContent" style="margin-top: 0;" class="inner-subBlock-wrapper">

          <div class="page-title-wrapper" style="display: none;">
              <div class="title blade-title-font">
                  {{renewalsTitle}}
              </div>
              <div class="basic-icon download-icon"
                  style="transform: translate(0, 15%) !important;" placement="bottom"
                  ngbTooltip="Download Renewals" (click)="exportRenewalsReport()">
              </div>
              <div class="basic-icon copy-icon"
                  style="transform: translate(0, 15%) !important;" placement="bottom"
                  ngbTooltip="Copy Renewals link" (click)="copyRenewalsLink()">
              </div>
              <!-- <i class="material-icons pullfloat-right" [routerLink]="['/myOrder']">close</i> -->
              <i class="material-icons closebutton-pullfloat-right"
                  [routerLink]="['/home']">close</i>
              <!--                                     
          <div class="download-icon" placement="bottom" ngbTooltip="Download Renewals"
              (click)="exportRenewalsReport()">
          </div>
          <div class="copy-icon" placement="bottom" ngbTooltip="Copy Renewals link"
              (click)="copyRenewalsLink()"></div>
          <i class="material-icons closebutton-pullfloat-right"
              [routerLink]="['/home']">close</i> -->
          </div>
          <div style="padding: 6px 0;" class="row filter-wrapper no-gutters">
              <div class="col-md-3 pl-0">
                  <div class="searchInputGroup">
                      <div class="searchIcon">
                          <img src="../images/new_ui/filter.png">
                      </div>
                      <input class="searchInput" type="text" placeholder="Filter"
                          onfocus="this.placeholder=''" onblur="this.placeholder='Filter'"
                          [(ngModel)]="searchRenewals">
                  </div>
              </div>
              <div class="col-md-3">
                  <ng-select [items]="vendorList" bindLabel="name" [multiple]="true"
                      [(ngModel)]="renewalsVendorFilter" placeholder="Select Vendor">
                      <ng-template ng-header-tmp>
                          <div>
                              <!-- <button class="btn btn-link" (click)="getInitialXRenewalList()">Select All</button> -->
                              <button class="btn btn-link clearAll"
                                  (click)="resetVendorFilter()">Clear
                                  All</button>
                          </div>
                      </ng-template>
                  </ng-select>
              </div>
              <div class="col-md-1"></div>
              <div class="col-md-3">
                  <ng-select [items]="statusList" bindLabel="name" [multiple]="true"
                      [(ngModel)]="renewalsStatusFilter" placeholder="Select Status">
                      <ng-template ng-header-tmp>
                          <div>
                              <!-- <button class="btn btn-link" (click)="getInitialXRenewalList()">Select All</button> -->
                              <button class="btn btn-link clearAll"
                                  (click)="resetStatusFilter()">Clear
                                  All</button>
                          </div>
                      </ng-template>
                  </ng-select>
              </div>
          </div>

          <div class="shared-outer-wrapper table-header-allign">
              <table matSort (matSortChange)="sortData($event)" class="white">
                  <thead>
                      <tr class="row">
                          <th mat-sort-header="vendor" class="align-center"
                              style="width:13%; padding-left: 10px;">VENDOR
                          </th>
                          <th mat-sort-header="endUserName" style="width: 40%;">END USER
                              NAME</th>
                          <th mat-sort-header="expiryDate" class="align-center"
                              style="width:13%;">
                              EXPIRY
                              DATE</th>
                          <th mat-sort-header="totalAmount" class="align-right col-2"
                              style="width:13%;padding-left:35px;">
                              AMOUNT(Ex)
                          </th>
                          <th style="width:10%;">STATUS</th>
                          <th class="align-center" style="width:10%;"></th>
                      </tr>
                  </thead>
              </table>

          </div>
          <div class="shared-outer-wrapper child-body renewal-list">
              <table matSort (matSortChange)="sortData($event)" class="white">
                  <thead hidden="true">
                      <tr class="row">
                          <th mat-sort-header="vendor" class="align-center"
                              style="width:13%; padding-left: 10px;">VENDOR
                          </th>
                          <th mat-sort-header="endUserName" style="width: 40%;">END USER
                              NAME</th>
                          <th mat-sort-header="expiryDate" class="align-center"
                              style="width:13%;">
                              EXPIRY
                              DATE</th>
                          <th mat-sort-header="totalAmount" class="align-right col-2"
                              style="width:13%;padding-left:35px;">
                              AMOUNT(Ex)
                          </th>
                          <th style="width:10%;">STATUS</th>
                          <th class="align-center" style="width:10%;"></th>
                      </tr>
                  </thead>
                  <tbody>
                      <ng-container *ngFor="let item of renewsList;index as i">
                          <ng-container *ngIf="filterRenewals(item)">
                              <tr class="row firstRow">

                                  <td class="align-left"
                                      style="width:13%; padding-left: 10px;">
                                      {{item?.out_vendor}}

                                  </td>

                                  <td class="truncate"
                                      style="width: 40%;padding-right: 20px;">
                                      {{item?.out_end_user}}
                                  </td>

                                  <td style="width:13%;">{{item?.out_expiry_date}}</td>

                                  <td class="align-right"
                                      style="width:13%;padding-right:15px;">
                                      {{item?.out_total_price |
                                      currency:'AUD':'symbol-narrow':'.2-2'}}
                                  </td>

                                  <td style="width:10%;padding-left:40px;">
                                      {{item?.out_status}}
                                  </td>

                                  <td class="align-center" style="width: 10%;">
                                      <button
                                          class="button button-red button-mid button-hover-white"
                                          (click)="manageRenewals(item,i)">Manage</button>
                                  </td>

                                  <div class="row downloadrow">
                                      <div style="width:13%; "
                                          class="downloadtextcol  truncate">
                                          {{item.out_agreement}}
                                      </div>
                                      <div class="downloadtextcol col-9 truncate"
                                          style="padding-left: 15px;">
                                          {{ item?.out_comments }}
                                      </div>
                                  </div>
                                  <div style="width: 10%; "></div>
                              </tr>
                          </ng-container>
                      </ng-container>
                  </tbody>
              </table>

          </div>

      </div>
      <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
      </loading-screen>

  </div>

  <div class="blockContainer narrow-sidebar narrow-sidebar-overflow" id="levelTwo"
      *ngIf="isMiniBlade">

      <div class="combination-loader">

          <div class="child-sidebar sidebar-loader">
              <child-header [title]="renewalsTitle" (closeEvent)="navigateTo('/manageRenewalsNew')"></child-header>
              <div class="page-title-wrapper page-title-padding" style="display: none;">

                  <div class="title blade-title-font">
                      {{renewalsTitle}}
                  </div>

                  <!-- <div>
                  <div class="basic-icon download-icon addnewuser-icon-narrowMode"
                      style="transform: translate(0, 15%) !important;" placement="bottom"
                      ngbTooltip="Create New End User" (click)="exportRenewalsReport()"></div>
                  <div class="basic-icon copy-icon download-icon-narrowMode"
                      style="transform: translate(0, 15%) !important;" placement="bottom"
                      ngbTooltip="Download Excel" (click)="copyRenewalsLink()">
                  </div>
              </div> -->

              </div>
              <div class="child-body renewal-list-mini">
                  <div class="searchInputGroup">
                      <div class="searchIcon search-carts">
                          <img src="../images/new_ui/filter.png">
                      </div>
                      <input class="searchInput searchInputGroup-small" type="text"
                          placeholder="Filter" onfocus="this.placeholder=''"
                          onblur="this.placeholder='Filter'" [(ngModel)]="searchRenewals">
                  </div>

                  <!-- <div class="searchInputGroup">
                  <div class="searchIcon search-carts">
                      <img src="../images/new_ui/filter.png">
                  </div>
                  <input class="searchInput searchInputGroup-small" type="text"
                      placeholder="Filter" onfocus="this.placeholder=''"
                      onblur="this.placeholder='Filter'" [(ngModel)]="searchRenewals">
              </div>

              <div class="renewal-filter">
                  <ng-select [items]="vendorList" bindLabel="name" [multiple]="true"
                      [(ngModel)]="renewalsVendorFilter" placeholder="Select Vendor">
                      <ng-template ng-header-tmp>
                          <div>
                              <button class="btn btn-link clearAll"
                                  (click)="resetVendorFilter()">Clear
                                  All</button>
                          </div>
                      </ng-template>
                  </ng-select>
              </div>

              <div class="renewal-filter">
                  <ng-select [items]="statusList" bindLabel="name" [multiple]="true"
                      [(ngModel)]="renewalsStatusFilter" placeholder="Select Status">
                      <ng-template ng-header-tmp>
                          <div>
                              <button class="btn btn-link clearAll"
                                  (click)="resetStatusFilter()">Clear
                                  All</button>
                          </div>
                      </ng-template>
                  </ng-select>
              </div> -->

                  <ng-container *ngFor="let item of renewsList;index as i">
                      <ng-container *ngIf="filterRenewals(item)">
                          <div class="menu-wrapper menu-wrapper-position"
                              (click)="manageRenewals(item,i)"
                              [class.active]="selectedSerial == item.out_serial">
                              <div class="total-div">
                                  <div class="narrow-title truncate">
                                      {{item.out_end_user}}
                                  </div>
                                  <span class="narrow-text">
                                      {{item.out_vendor}} | {{item.out_program}}
                                  </span><br>
                                  <span class="narrow-text">
                                      {{item.out_agreement?item.out_agreement:item.out_opportunity_id}}</span>
                                  <!-- <span class="narrow-text">
                                  {{item.out_opportunity_id}}</span> -->
                              </div>
                          </div>
                      </ng-container>

                  </ng-container>
              </div>
          </div>

          <div class="child-loader">
              <router-outlet></router-outlet>
          </div>

      </div>

  </div>

</div>